import React__default from 'react';
import { E as EditUserProfileProvider, a as EditUserProfile } from './index-358226c7.js';
import './ui/Modal.js';
import 'prop-types';
import 'react-dom';
import './LocalizationContext-b021af8f.js';
import './stringSet-91746bf1.js';
import './index-353f13f3.js';
import './index-1fd114b0.js';
import './ui/IconButton.js';
import './_rollupPluginBabelHelpers-8e4fae98.js';
import './ui/Icon.js';
import './index-41a6f4f2.js';
import './index-a611bd38.js';
import './utils-9ef11656.js';
import './useSendbirdStateContext.js';
import './withSendBird.js';
import './ui/Input.js';
import './ui/Avatar.js';
import './tslib.es6-83aa13f5.js';
import './ui/ImageRenderer.js';
import './uuid-6d14d007.js';
import './ui/TextButton.js';
import './color-2863fbbe.js';
import './actionTypes-189daf51.js';

var EditProfile = function EditProfile(props) {
  var onEditProfile = props.onEditProfile,
      onCancel = props.onCancel,
      onThemeChange = props.onThemeChange;
  return /*#__PURE__*/React__default.createElement(EditUserProfileProvider, {
    onEditProfile: onEditProfile,
    onCancel: onCancel,
    onThemeChange: onThemeChange
  }, /*#__PURE__*/React__default.createElement(EditUserProfile, null));
};

export { EditProfile as default };